<template>
  <n-modal class="page-record-create" :loading="$var('load')" @close="$emit('close')">
    <div class="line">
      <n-card class="info" :loading="$var('load')">
        <template #header>
          <h3>Информация</h3>
        </template>
        <n-items>
          <n-input title="Проект" :value="project.title" text />
          <n-input title="Дата заполнения" v-bind="$form.input('publishedAt')" />
        </n-items>
      </n-card>
    </div>
    
    <n-card :loading="$var('load')">
      <template #header>
        <h3>{{ journal.title }}</h3>
      </template>
      <n-items>
        <n-input title="№ п.п." v-bind="$form.input('number')" />
        <n-datepicker title="Дата и время записи" v-bind="$form.input('date')" />
        <n-input title="Время между записями" v-bind="$form.input('time')" />
        <n-input title="Сведения о ходе бетонирования и бетоне" v-bind="$form.input('information')" />
        <n-input title="№ бетонолитных труб" v-bind="$form.input('pipeNumber')" />
        <n-input title="Диаметр бетонолитной трубы, см" v-bind="$form.input('diameter')" />
        <n-input title="Количество бетона, м3, уложенного в блок, анкеровка контрольных образцов бетона" v-bind="$form.input('concreteCount')" />
        <n-input title="Средняя скорость бетонирования, м/ч" v-bind="$form.input('speed')" />
        <n-input title="Отметка верха оболочки колодца ограждения, котлована и т.д." v-bind="$form.input('topMark')" />
        <n-input title="Отметка грунта в полости оболочки, диаметр скважины, котлована, м" v-bind="$form.input('earthMark')" />
        <n-input title="Отсчёт по трубе, м" v-bind="$form.input('pipeReport')" />
        <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: у трубы " v-bind="$form.input('deep1')" />
        <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 1" v-bind="$form.input('deep2')" />
        <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 2" v-bind="$form.input('deep3')" />
        <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 3" v-bind="$form.input('deep4')" />
        <n-input title="Глубина в контрольных точках шахт, котлованов (в оболочках, уширениях только у трубы), м: № 4" v-bind="$form.input('deep5')" />
        <n-input title="Заглубление трубы в бетонную смесь, м" v-bind="$form.input('deepening')" />
        <n-input title="Средний слой поверхности бетона" v-bind="$form.input('layer')" />
        <n-input title="Уровень бетонной смеси в трубе от низа, м" v-bind="$form.input('level')" />
      </n-items>
    </n-card>
    
    <n-card>
      <n-divide>
        <div></div>
        <n-button color="success" @click="save">Сохранить</n-button>
      </n-divide>
    </n-card>
  </n-modal>
</template>

<script>
export default {
  name: 'PageRecordCreate',
  props: [ 'project', 'journal', ],
  data() {
    return {
      figures: [],
    }
  },
  created() {
    this.$form.init({
      publishedAt: $app.date.format($app.date.now()),
    })
  },
  methods: {
    save() {
      this.$var('load', true)
      const data = {
        record: this.$form.get(),
      }
      $api.journals.records.create(this.project.id, 'spec35', data).then((response) => {
        this.$emit('reload')
        this.$emit('close')
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .page-record-create {
    
    .line {
      display: flex;
      align-items: flex-start;
      
      & > * {
        white-space: normal;
        display: inline-block;
        margin-bottom: 0;
        flex-grow: .4;
        flex-basis: 1px;
      }
      .items {
        margin-left: 0;
        flex-grow: .6;
      }
    }
    
    
    .weather {
      .unit {
        margin: 0 20px 0 5px;
      }
      .temperature {
        margin-left: 20px;
      }
      .temperature, .wind {
        width: 100px;
      }
    }
    
    .add {
      margin-top: 5px;
      font-size: .8em;
      opacity: .7;
      cursor: pointer;
    }
  }
</style>
